import styled from 'styled-components';

export const OrderStepContainer = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.borderRadius};
`;

export const OrderStepHeader = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  > svg {
    :hover {
      cursor: pointer;
    }
  }
`;

export const OrderStepBody = styled.div<{
  $isVisible: boolean;
  $overflow?: string;
}>`
  overflow: ${({ $overflow: overflow }) => overflow || 'hidden'};
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`;

export const OrderStepBodyInner = styled.div`
  padding: 20px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
`;
